import React, { useEffect, useState } from "react";
import {
  Content,
  Row,
  Col,
  Box,
  Button,
  Inputs,
} from "adminlte-2-react";
import _ from "lodash";
import controller from "./duck";
import { useSelector, useDispatch } from "react-redux";

import { parseJwt } from "../utils/utils";
import Loader from "../utils/Loader";
import "react-phone-input-2/lib/style.css";
import ReferenciaObligatorios from "../utils/etiquetaObligatorio/ReferenciaObligatorios";
import Etiqueta from "../utils/etiquetaObligatorio/Etiqueta";

const { Text } = Inputs;

export default function ChangePass({ history, match }) {
  const dispatch = useDispatch();
  const modelChangePass = useSelector((state) => state.changePass);
  const [oldPassword, setOldPassword] = useState(null);
  const [newPassword, setNewPassword] = useState(null);
  const [newPasswordConfirm, setNewPasswordConfirm] = useState(null);

  const processError = (errorForUser) => {
    alert(errorForUser);
    dispatch(controller.changePassDuck.actions.clear());
  };

  useEffect(() => {
    const PASSWORD_EDIT_SUCCESS = 200;
    const WRONG_PASSWORD = 10;

    const data = modelChangePass?.data?.data;
    const error = modelChangePass?.error;
    const errorMessage = modelChangePass?.error?.response?.data?.mensaje;

    if (error) {
    
      processError(errorMessage || 'Ocurrió un error al realizar la operación');
    }
    if (data) {

      if (data?.status !== PASSWORD_EDIT_SUCCESS) {
        let errorForUser = '';
        if (data?.status === WRONG_PASSWORD) {
          errorForUser = 'La contraseña es incorrecta';
        } else {
          errorForUser = 'Ocurrió un error al intentar actualizar la contraseña';
        }
        processError(errorForUser);
        return;
      }
      alert("Contraseña actualizada");
      dispatch(controller.changePassDuck.actions.clear());
      history.push('/landing')
    }
  }, [modelChangePass]);



  const submit = () => {
    if (!oldPassword || !newPassword) {
      return alert("Por favor complete todos los campos");
    }
    if (newPassword !== newPasswordConfirm) {
      return alert("Las contraseñas no coinciden");
    }
    const token = localStorage.getItem("token");
    if (!token) {
      history.push("/login");
      return;
    }
    const decodedToken = parseJwt(token);

    const data = {
      id: decodedToken.id,
      newPassword,
      oldPassword,
    };
    dispatch(controller.changePassThunk(data));
  }
  return (
    <Content
      title="Reestablecer contraseña"
      browserTitle="Reestablecer contraseña"
      show={false}
    >
      <Row>
        <Col md="4" mdOffset="4">
          <Box title="Reestablecer contraseña" footer={<>
            <Button
              type="primary"
              text={
                <Loader loaderColor="#ffffff" isLoading={modelChangePass.loading}>
                  Guardar
                </Loader>
              }
              disabled={modelChangePass.loading}
              pullRight={true}
              onClick={submit}
            />
          </>}>

            <ReferenciaObligatorios/>

            <Text
              inputType="password"
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Contraseña actual" obligatorio={true} />}              
              onChange={(evt) => setOldPassword(evt.target.value)}
            />          
            <Text
              inputType="password"
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Nueva contraseña" obligatorio={true} />}
              onChange={(evt) => setNewPassword(evt.target.value)}
            />
            <Text
              inputType="password"
              labelPosition="above"
              size="sm"
              label={<Etiqueta texto="Confirmar contraseña" obligatorio={true} />}              
              onChange={(evt) => setNewPasswordConfirm(evt.target.value)}
            />
          </Box>
        </Col>
      </Row>
    </Content>
  );
}
